import {MinimalFileObject} from "@components/file-object/types";

export const fieldChooser = (mode: 'name'|'date') => (item: MinimalFileObject) => {

  return mode=='name'?item.name || item.originalName : item.created
}
